import type { PlanResponse, PlanValueProp } from "@Light/services/lightTypes";
import type { PlanFeatures } from "@Light/utils/planFeatures";
import type { RateOfferProps } from "./RateOffer";

/**
 * Presents the rate as a grid plan that's required by a partner's program.
 */
export function getRequiredPlanRateProps(
  features: PlanFeatures,
  rate?: PlanResponse,
): Pick<
  RateOfferProps,
  "badge" | "planName" | "headline" | "hidePrice" | "valueProps"
> {
  return {
    badge: "Required with program",
    planName: "Grid Energy Plan",
    headline: gridHeadline(features),
    hidePrice: true,
    valueProps:
      rate &&
      [gridRateValueProp(rate), ...rate.presentation.value_propositions].slice(
        0,
        3,
      ),
  };
}

const gridHeadline = (features: PlanFeatures) => {
  const devices = [
    features.solarBuyback && "solar",
    features.storageCredit && "battery",
  ].filter(Boolean);
  const beyond = devices.length ? `, beyond your ${devices.join(" and ")}` : "";
  return `Covers electricity you use from the grid${beyond}.`;
};

const gridRateValueProp = (rate: PlanResponse): PlanValueProp => {
  const term = rate.term_months > 1 ? ` for ${rate.term_months} months` : "";
  return {
    id: "required_plan_rate",
    // TODO: Add to backend icons
    icon: "home-smile" as PlanValueProp["icon"],
    text: `${rate.avg_cents_per_kwh_1000}¢ per kWh for grid-only power at 1,000 kWh${term}`,
    callouts: [],
  };
};
